import { Box, chakra, Text as ChakraText } from "@chakra-ui/react";
import {
  AmExColorIcon as Amex,
  ApplePayIcon as ApplePay,
  MaestroColorIcon as Maestro,
  MastercardColorIcon as MasterCard,
  PayPalColorIcon as PayPal,
  PayPalLogo,
  VisaColorIcon as Visa,
  KlarnaLogo as Klarna
} from "components/SvgIcons";

const iconBaseStyle = {
  baseStyle: {
    width: "3.25rem",
    height: "1.875rem",
    mr: "0.5rem"
  }
};

export const Container = chakra(Box, {
  baseStyle: {
    pb: 2,
    width: "100% !important",
    maxWidth: "initial !important"
  }
});

export const Title = chakra(ChakraText, {
  baseStyle: {
    mt: 0,
    pt: -6
  }
});

export const Wrapper = chakra(Box, {
  baseStyle: {
    display: "flex",
    maxWidth: "785px",
    m: "0 auto"
  }
});

export const TextWrapper = chakra(Box, {
  baseStyle: {
    display: "flex",
    flex: 2,
    justifyContent: "center"
  }
});

export const Text = chakra(ChakraText, {
  baseStyle: {
    maxWidth: { base: "280px", md: "100%" },
    width: "100%",
    margin: "0 auto"
  }
});

export const CardsWrapper = chakra(Box, {
  baseStyle: {
    display: "flex",
    flex: 1
  }
});

export const VisaIcon = chakra(Visa, iconBaseStyle);

export const MaestroIcon = chakra(Maestro, iconBaseStyle);

export const MasterCardIcon = chakra(MasterCard, iconBaseStyle);

export const PayPalIcon = chakra(PayPal, iconBaseStyle);

export const PayPalLogoIcon = chakra(PayPalLogo, iconBaseStyle);

export const ApplePayIcon = chakra(ApplePay, iconBaseStyle);

export const AmexIcon = chakra(Amex, iconBaseStyle);

export const KlarnaIcon = chakra(Klarna, iconBaseStyle);
